// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__8TIyp","alertText":"styles_alertText__Yn0di"};